<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import heroPhotoMobile from "../assets/final_photos/DSC_0249.jpg?webp&w=768&quality=65&imagetools";
	import heroPhoto from "../assets/final_photos/DSC_0249.jpg?webp&w=1440&quality=65&imagetools";
	import AboutStats from "../components/AboutStats.svelte";
	import CompanyValues from "../components/CompanyValues.svelte";
	import ContactForm from "../components/ContactForm.svelte";
	import FbHiring from "../components/FbHiring.svelte";
	import OurCertificates from "../components/OurCertificates.svelte";
	import PageHero from "../components/PageHero.svelte";
	import WeSupport from "../components/WeSupport.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./AboutUs.translations.json" with { type: "json" };
	import type { AboutUsProps } from "./AboutUsProps.js";

	const _: AboutUsProps = $props();
	const translate = getTranslate(translations);
</script>

<Layout>
	<PageHero
		image={heroPhoto}
		mobileImage={heroPhotoMobile}
		alt={translate("heroAlt")}
		heading={translate("heroHeading")}
		text={translate("heroText")}
		text2={translate("heroText2")}
		text3={translate("heroText3")}
		text4={translate("heroText4")}
		buttonText={translate("heroButtonText")}
		objectPosition="center -21rem"
		brightness={120}
	/>
	<AboutStats />
	<CompanyValues />
	<OurCertificates />
	<WeSupport />
	<FbHiring />
	<ContactForm heading="default" />
</Layout>
